import "./IntroTitulos.css";
import { useState } from "react";
import { verificaAdmin } from "../../../../components/utils/verificaAdmin";
import AdminTitulo from "./AdminTitulo/AdminTitulo";

function IntroTitulos({
  titulos,
  loading,
  localizacao,
  ordem,
  ordemsubtitulo,
  atualizarTitulos,
}) {
  const [abrirAdminTitulo, setAbrirAdminTitulo] = useState(false);

  if (loading || !Array.isArray(titulos)) return null;

  const isAdmin = verificaAdmin();

  const tituloObj = titulos.find(
    t =>
      t.localizacao === localizacao &&
      t.ordem === ordem
  );

  const subtituloObj =
    ordemsubtitulo !== undefined
      ? titulos.find(
        t =>
          t.localizacao === localizacao &&
          t.ordem === ordemsubtitulo
      )
      : null;

  const titulo = tituloObj?.descricao?.trim() || "";
  const subtitulo = subtituloObj?.descricao?.trim() || "";

  if (!titulo && !subtitulo && !isAdmin) return null;

  return (
    <>
      <section className="intro-part2-title">
        {isAdmin && (
          <button
            className="btn-editar-banner"
            onClick={() => setAbrirAdminTitulo(true)}
          >
            Editar
          </button>
        )}

        {titulo && <h2>{titulo}</h2>}
        {subtitulo && <p>{subtitulo}</p>}
      </section>

      {abrirAdminTitulo && (
        <AdminTitulo
          tituloObj={tituloObj}
          subtituloObj={subtituloObj}
          onClose={() => setAbrirAdminTitulo(false)}
          onAtualizado={atualizarTitulos}
        />
      )}
    </>
  );
}

export default IntroTitulos;